import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { SOCIALS } from "../lib/api";
import { InstagramIcon, TikTokIcon, FacebookIcon } from "./Icons";

const LINKS = [
  { to: "/", label: "Home", end: true },
  { to: "/research", label: "Research" },
  { to: "/prepare", label: "Prepare" },
  { to: "/our-story", label: "Our Story" },
  { to: "/the-science", label: "The Science" },
  { to: "/quiz", label: "Golfer Profile" },
  { to: "/contact", label: "Contact" },
];

export const Masthead = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => { setOpen(false); }, [pathname]);
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  return (
    <>
      <header className="mast" data-testid="site-masthead">
        <Link className="mast-mark" to="/" data-testid="masthead-logo" onClick={() => setOpen(false)}>
          <img src="/brand/mark-t.png" alt="Dialed In" />
          <span>Dialed&nbsp;In</span>
        </Link>
        <nav className="mast-nav" data-testid="masthead-nav">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) => `mast-link${isActive ? " active" : ""}`}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </NavLink>
          ))}
          <Link className="mast-cta" to="/#join" data-testid="masthead-join-cta">Join Dialed In</Link>
        </nav>
        <button
          className={`burger${open ? " open" : ""}`}
          onClick={() => setOpen(!open)}
          aria-label="Menu"
          data-testid="mobile-menu-toggle"
        >
          <span /><span /><span />
        </button>
      </header>

      <div className={`mmenu${open ? " open" : ""}`} data-testid="mobile-menu">
        {LINKS.map((l) => (
          <Link key={l.to} className="mmenu-link" to={l.to} onClick={() => setOpen(false)}>
            {l.label}
          </Link>
        ))}
        <Link className="cta" to="/#join" style={{ marginTop: 30, justifyContent: "center" }} onClick={() => setOpen(false)} data-testid="mobile-menu-join-cta">
          Join Dialed In
        </Link>
        <div className="mmenu-social">
          <a href={SOCIALS.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><InstagramIcon /></a>
          <a href={SOCIALS.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok"><TikTokIcon /></a>
          <a href={SOCIALS.facebook} target="_blank" rel="noopener noreferrer" aria-label="Dialed In Community"><FacebookIcon /></a>
        </div>
      </div>
    </>
  );
};
